export const COLUMNSRESULTADOP = [
    {
        header: "Período",
        accessorKey: "_new_periodo_value",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Desempeño",
        accessorKey: "new_desempenio",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Act. Áulicas",
        accessorKey: "new_creditosactaulicas",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    // {
    //     header: "Act. Prod. Contenido",
    //     accessorKey: "new_crditosactprodcontenido",
    //     size: 50,
    //     minSize: 100,
    //     maxSize: 200,
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    // },
    {
        header: "Act. Gestión",
        accessorKey: "new_creditosactgestion",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    // {
    //     header: "Act. Extensión",
    //     accessorKey: "new_creditosactextension",
    //     size: 50,
    //     minSize: 100,
    //     maxSize: 200,
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    // },
    // {
    //     header: "Act. Investigación",
    //     accessorKey: "new_creditosactinvestigacion",
    //     size: 50,
    //     minSize: 100,
    //     maxSize: 200,
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    // },
    {
        header: "Créditos totales",
        accessorKey: "new_creditostotales",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },

    // {
    //     header: "Créditos",
    //     accessorKey: "new_name",
    //     size: 50,
    //     minSize: 100,
    //     maxSize: 200,
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    // },
    // {
    //     header: "Materias",
    //     accessorKey: "new_name",
    //     size: 50,
    //     minSize: 100,
    //     maxSize: 200,
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    // },
];

export const COLUMNSRESULTADOG = [
    {
        header: "Período",
        accessorKey: "_new_periodo_value",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Desempeño",
        accessorKey: "new_desempenio",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Act. Áulicas",
        accessorKey: "new_creditosactaulicas",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Act. Prod. Contenido",
        accessorKey: "new_crditosactprodcontenido",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Act. Gestión",
        accessorKey: "new_creditosactgestion",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Act. Extensión",
        accessorKey: "new_creditosactextension",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Act. Investigación",
        accessorKey: "new_creditosactinvestigacion",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Créditos totales",
        accessorKey: "new_creditostotales",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },

    // {
    //     header: "Créditos",
    //     accessorKey: "new_name",
    //     size: 50,
    //     minSize: 100,
    //     maxSize: 200,
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    // },
    // {
    //     header: "Informe",
    //     accessorKey: "new_name",
    //     size: 50,
    //     minSize: 100,
    //     maxSize: 200,
    //     Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    // },
];

export const COLUMNSACOMPANAMIENTOS = [
    {
        header: "Materia",
        accessorKey: "_new_materia_value",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Observador",
        accessorKey: "_new_observador_value",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Fecha de la Observación",
        accessorKey: "new_fechadelaobservacin",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Momento de la Clase",
        accessorKey: "new_momentodelaclaseenqueseacompaa",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Didácticas de 1er Nivel",
        accessorKey: "new_didacticasde1ernivel",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Didácticas de 2do Nivel",
        accessorKey: "new_didctivasde2donivel",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
    {
        header: "Diferencial",
        accessorKey: "new_informaciondiferencial",
        size: 50,
        minSize: 100,
        maxSize: 200,
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
    },
];